import { render, staticRenderFns } from "./WebPartFormSubmitDesigner.vue?vue&type=template&id=0a2194b3&"
import script from "./WebPartFormSubmitDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormSubmitDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports